






import { Component, Vue } from 'vue-property-decorator';
import AnimaArticle from '@/components/AnimaArticle.vue';

@Component({
  components: {
    AnimaArticle,
  },
})
export default class License extends Vue {}
